/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineUp: {
  name: 'line-up';
  data: string;
} = {
  name: 'line-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.36 17.768a1 1 0 0 0 1.408-.128l4.452-5.342 3.541 2.125a2 2 0 0 0 2.548-.413L19 9.703V12a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1h-5a1 1 0 1 0 0 2h2.826l-4.036 4.708-3.541-2.125a2 2 0 0 0-2.565.435L3.232 16.36a1 1 0 0 0 .128 1.408Z" fill="currentColor"/></svg>`,
};
